function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E4E4E7;}\n\t.st2{fill:none;stroke:#444B54;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#AFAFBC;}\n\t.st4{fill:#EAD063;}\n\t.st5{fill:#242426;}\n\t.st6{fill:#F9DED4;}\n\t.st7{fill:#D8AC9E;}\n\t.st8{fill:#FFD0FF;}\n\t.st9{fill:#6575C1;}\n\t.st10{fill:#786F74;}\n\t.st11{fill:#9B9BA5;}\n\t.st12{fill:#FFD2EA;}\n\t.st13{fill:#B78BA4;}\n\t.st14{fill:#444B54;}\n\t.st15{fill:#5D5D8C;}\n\t.st16{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M67,90.8c0-1.7-1.3-3-3-3s-3,1.3-3,3v12.9c0,1.7,1.3,3,3,3s3-1.3,3-3V90.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64,115.8c-1.7,0-3,1.3-3,3v4.9c0,1.7,1.3,3,3,3s3-1.3,3-3v-4.9C67,117.2,65.7,115.8,64,115.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38,90.8c0.5,0,0.9-0.1,1.3-0.3l19.4-9.7l10.8,0.1l19.1,9.6c0.4,0.2,0.9,0.3,1.3,0.3c1.1,0,2.2-0.6,2.7-1.7   c0.7-1.5,0.1-3.3-1.3-4l-18.3-9.1V3.8c0-1.7-1.3-3-3-3H58c-1.7,0-3,1.3-3,3v72.1l-18.3,9.2c-1.5,0.7-2.1,2.5-1.3,4   C35.8,90.1,36.9,90.8,38,90.8z"
}));

function SvgRecovered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovered);
export default __webpack_public_path__ + "static/media/recovered.b7254d04.svg";
export { ForwardRef as ReactComponent };